module.exports = __webpack_public_path__ + "media/src/assets/Images/InputCheck-e1dd69199ec3c96c321c3ff1a103b556.svg";